import { addDays } from 'date-fns'
import { popupPersistentDomain } from '../domain/popup-domain'

export const hasPopupBeenViewedWithinDays = (popupId: number, days: number) => {
    const viewedDate = popupPersistentDomain.data.viewed[popupId]

    if (!viewedDate) {
        return false
    }

    return addDays(viewedDate, days) > new Date()
}
